// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__QauCq","sliderwatchbtn":"Slider_sliderwatchbtn__YRXLG","sliderbuybtn":"Slider_sliderbuybtn__mptzI","slideritemtitle":"Slider_slideritemtitle__99elp"};